import { TaxesRouteNames } from "./taxes.model";

export enum TaxesQueryParamName {
	AssetId = "assetId",
	AssetWalletId = "assetWalletId",
	NavigationFrom = "NavigationFrom",
	NavigationVariant = "NavigationVariant",
	NavigationTo = "NavigationTo",
	LeftSelectionWalletId = "LeftSelectionWalletId",
	RightSelectionWalletId = "RightSelectionWalletId",
	FromTradeFlow = "fromTradeFlow",
	CryptoSwap = "CryptoSwap",
	IsRefund = "IsRefund",
	NavigateTo = "NavigateTo",
	SliceNumber = "SliceNumber",
	FromTrxDetails = "FromTrxDetails",
	stableCoinWalletId = "stableCoinWalletId"
}
export interface TaxesQueryParamsCollection {
	[TaxesQueryParamName.AssetId]: string;
	[TaxesQueryParamName.AssetWalletId]: string;
	[TaxesQueryParamName.NavigationFrom]: TaxesRouteNames;
	[TaxesQueryParamName.NavigationVariant]: string;
	[TaxesQueryParamName.NavigationTo]: TaxesRouteNames;
	[TaxesQueryParamName.LeftSelectionWalletId]: string;
	[TaxesQueryParamName.RightSelectionWalletId]: string;
	[TaxesQueryParamName.FromTradeFlow]: string;
	[TaxesQueryParamName.CryptoSwap]: string;
	[TaxesQueryParamName.IsRefund]: string;
	[TaxesQueryParamName.NavigateTo]: string;
	[TaxesQueryParamName.SliceNumber]: number;
	[TaxesQueryParamName.stableCoinWalletId]: string;
	[TaxesQueryParamName.FromTrxDetails]: "true" | "false";
}
